import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';

// Per-society allow/deny switches for sending billing documents by channel.
// The society always goes in X-Society-Id (super admins must send it) — it's the
// community being configured, not the admin's active one.

// Validation 400s use { status, message: "body: …" }; others the standard envelope.
export const communicationSettingErrorMessage = (err) =>
    String(err?.response?.data?.message || err?.message || 'Something went wrong')
        .replace(/^(body|query|params):\s*/, '');

// GET → { society_id, channels[{code,label}], document_types[{code,label,channels:{CODE:bool}}] }
export const getCommunicationSettingsReq = (societyId) =>
    axiosInstance.get(apiEndpoints.CTRL_COMMUNICATION_SETTINGS_API, {
        headers: { 'X-Society-Id': societyId },
    });

// PUT — partial: send only changed switches. Returns the full resolved matrix.
// settings: [{ document_type, channel, is_enabled }]
export const updateCommunicationSettingsReq = (societyId, settings) =>
    axiosInstance.put(apiEndpoints.CTRL_COMMUNICATION_SETTINGS_API, { settings }, {
        headers: { 'X-Society-Id': societyId },
    });
